export class ShareSurveyToPatientModal{
    constructor(
        private selectedPatients:any[],
        private surveyId:string
    ){}
}